import Card from './style'

interface IActionCard {
  tag?: string
  icon: any
  value: string
  onClick?: any
  disabled?: boolean
  id?: string
}

export default function ActionCard(props: IActionCard) {
  const { value, icon, tag, disabled, onClick } = props

  return (
    <Card
      {...props}
      onClick={() => {
        if (disabled) {
          console.log('Card desabilitado')
        } else if (onClick) {
          onClick() // Executa somente se onClick existir
        }
      }}
    >
      {tag && <span className="ac-tag">{tag}</span>}
      <img className="ac-icon" src={icon} alt="card icon" />
      <div>
        <span className="ac-title">{value}</span>
      </div>
    </Card>
  )
}
